import { Modal, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Login from "./Login"; // Your actual login form
import { useEffect, useState } from "react";
import VendorRegister from "./VendorRegister";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../State/Auth/Action";

const LoginModal = ({ alwaysOpen = false }) => {
  const navigate = useNavigate();
  const [view, setView] = useState("login"); // Default to login
  const [open, setOpen] = useState(alwaysOpen);
  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");
  const { auth } = useSelector((store) => store);

  // Reset view to "login" every time modal opens
  useEffect(() => {
    if (open) {
      setView("login");
    }
  }, [open]);

  useEffect(() => {
    if (jwt) {
      dispatch(getUser(jwt));
    }
  }, [jwt, dispatch]);


  const handleModalClose = () => {
    if (alwaysOpen) {
      navigate("/");
    } else {
      setOpen(false);
    }
  };
  const handleClose = () => {
    if (alwaysOpen) {
      navigate("/");
    } else {
      setOpen(false);
      navigate("/");
    }
  };
  const handleModalOpen = () => {
    setOpen(true);
  };
  const renderContent = () => {

    if (view === "register")
      return <VendorRegister handleClose={handleModalClose} switchToLogin={() => setView("login")} />;
    return <Login handleClose={handleModalClose} switchToRegister={() => setView("register")} />;
  };

  return <Modal open={open} {...(!auth?.isLoading && { onClose: handleClose })} aria-labelledby="login-modal-title" aria-describedby="login-modal-description" >
    <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: 470, bgcolor: "white", boxShadow: 24, p: 3, borderRadius: 2 } // ✅ Ensure white background
    }>


      {/* Replace this with your actual login form */}
      {renderContent()}
    </Box>
  </Modal>;
};

export default LoginModal;
